(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riosso-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('.rp');
  if (!section) return;

  var variants = JSON.parse(document.getElementById('rp-variants-json').textContent);
  var handle = section.dataset.productHandle;
  var form = document.getElementById('rp-form');
  var variantInput = document.getElementById('rp-variant-id');
  var addBtn = document.getElementById('rp-add-btn');
  var addText = document.getElementById('rp-add-text');
  var priceEl = document.getElementById('rp-price');
  var installEl = document.getElementById('rp-installment');
  var gallery = document.getElementById('rp-gallery');
  var counterEl = document.getElementById('rp-counter-current');
  var stickyBar = document.getElementById('rp-sticky');
  var stickyBtn = document.getElementById('rp-sticky-btn');
  var stickyPrice = document.getElementById('rp-sticky-price');
  var colorName = document.getElementById('rp-color-name');

  var selected = {};
  document.querySelectorAll('.rp__option').forEach(function(fs) {
    var idx = fs.dataset.optionIndex;
    var active = fs.querySelector('.rp__swatch--active, .rp__size--active');
    if (active) selected[idx] = active.dataset.value;
  });

  /* Variant matching */
  function findVariant() {
    return variants.find(function(v) {
      return Object.keys(selected).every(function(idx) {
        return v.options[parseInt(idx)] === selected[idx];
      });
    });
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
  }

  function updateUI(variant) {
    if (!variant) return;
    variantInput.value = variant.id;
    var url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    history.replaceState(null, '', url.toString());

    var html = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var disc = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
      html = '<span class="rp__price-compare">' + formatMoney(variant.compare_at_price) + '</span>' +
             '<span class="rp__price-current rp__price-current--sale">' + formatMoney(variant.price) + '</span>' +
             '<span class="rp__price-badge">%' + disc + '</span>';
    } else {
      html = '<span class="rp__price-current">' + formatMoney(variant.price) + '</span>';
    }
    priceEl.innerHTML = html;
    installEl.textContent = '4 taksitte ' + formatMoney(Math.round(variant.price / 4));
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    if (variant.available) {
      addBtn.disabled = false;
      addText.textContent = 'Sepete Ekle';
      if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = 'Sepete Ekle'; }
    } else {
      addBtn.disabled = true;
      addText.textContent = 'Tükendi';
      if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Tükendi'; }
    }

    updateSoldoutSizes(variant);
  }

  function updateSoldoutSizes(currentVariant) {
    document.querySelectorAll('.rp__option--size .rp__size').forEach(function(btn) {
      var idx = btn.dataset.optionIndex;
      var val = btn.dataset.value;
      var testSelected = Object.assign({}, selected);
      testSelected[idx] = val;
      var match = variants.find(function(v) {
        return Object.keys(testSelected).every(function(i) {
          return v.options[parseInt(i)] === testSelected[i];
        });
      });
      btn.classList.toggle('rp__size--soldout', !match || !match.available);
    });
  }

  /* Option click delegation */
  section.addEventListener('click', function(e) {
    var swatch = e.target.closest('.rp__swatch');
    var size = e.target.closest('.rp__size');
    if (swatch && !swatch.classList.contains('rp__swatch--active')) {
      var parent = swatch.closest('.rp__option');
      parent.querySelectorAll('.rp__swatch').forEach(function(s) { s.classList.remove('rp__swatch--active'); });
      swatch.classList.add('rp__swatch--active');
      selected[swatch.dataset.optionIndex] = swatch.dataset.value;
      if (colorName) colorName.textContent = swatch.dataset.value;
      var v = findVariant();
      if (v) { updateUI(v); scrollToVariantImage(v); }
    }
    if (size && !size.classList.contains('rp__size--active') && !size.classList.contains('rp__size--soldout')) {
      var parent = size.closest('.rp__option');
      parent.querySelectorAll('.rp__size').forEach(function(s) { s.classList.remove('rp__size--active'); });
      size.classList.add('rp__size--active');
      selected[size.dataset.optionIndex] = size.dataset.value;
      var v = findVariant();
      if (v) updateUI(v);
    }
  });

  function scrollToVariantImage(variant) {
    if (!variant.featured_image) return;
    var slides = gallery.querySelectorAll('.rp__slide img');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].src.indexOf(variant.featured_image.id) > -1 || i === 0) {
        /* fallback: try matching alt text */
      }
    }
    /* Scroll to the variant image index via the Shopify media position */
    if (variant.featured_media) {
      var target = gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      if (target) {
        var isDesktop = window.innerWidth >= 768;
        gallery.scrollTo({ top: isDesktop ? target.offsetTop : 0, left: isDesktop ? 0 : target.offsetLeft, behavior: 'smooth' });
        updateThumb(parseInt(target.dataset.index));
      }
    }
  }

  /* Gallery scroll counter */
  var scrollTimer;
  gallery.addEventListener('scroll', function() {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function() {
      var isDesktop = window.innerWidth >= 768;
      var slides = gallery.querySelectorAll('.rp__slide');
      var scrollPos = isDesktop ? gallery.scrollTop : gallery.scrollLeft;
      var slideSize = isDesktop ? slides[0].offsetHeight : slides[0].offsetWidth;
      var idx = Math.round(scrollPos / slideSize);
      if (counterEl) counterEl.textContent = idx + 1;
      updateThumb(idx);
    }, 50);
  });

  function updateThumb(idx) {
    document.querySelectorAll('.rp__thumb').forEach(function(t, i) {
      t.classList.toggle('rp__thumb--active', i === idx);
    });
  }

  /* Thumb clicks */
  document.querySelectorAll('.rp__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var idx = parseInt(this.dataset.index);
      var slide = gallery.querySelectorAll('.rp__slide')[idx];
      if (!slide) return;
      var isDesktop = window.innerWidth >= 768;
      gallery.scrollTo({ top: isDesktop ? slide.offsetTop : 0, left: isDesktop ? 0 : slide.offsetLeft, behavior: 'smooth' });
      updateThumb(idx);
    });
  });

  /* Lightbox */
  var lightbox = document.getElementById('rp-lightbox');
  var lightboxTrack = document.getElementById('rp-lightbox-track');
  var lightboxCounter = document.getElementById('rp-lightbox-counter');
  var totalMedia = gallery ? gallery.querySelectorAll('.rp__slide').length : 0;

  gallery.addEventListener('click', function(e) {
    if (e.target.closest('.rp__img')) {
      var slide = e.target.closest('.rp__slide');
      var idx = parseInt(slide.dataset.index);
      openLightbox(idx);
    }
  });

  function openLightbox(idx) {
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    var slides = lightboxTrack.querySelectorAll('.rp__lightbox-slide');
    if (slides[idx]) lightboxTrack.scrollLeft = slides[idx].offsetLeft;
    lightboxCounter.textContent = (idx + 1) + '/' + totalMedia;
    lightbox.focus();
  }

  function closeLightbox() {
    lightbox.hidden = true;
    document.body.style.overflow = '';
  }

  document.getElementById('rp-lightbox-close').addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', function(e) { if (e.target === lightbox) closeLightbox(); });

  lightboxTrack.addEventListener('scroll', function() {
    var idx = Math.round(lightboxTrack.scrollLeft / lightboxTrack.offsetWidth);
    lightboxCounter.textContent = (idx + 1) + '/' + totalMedia;
  });

  /* Size guide modal */
  var modal = document.getElementById('rp-modal');
  if (modal) {
    var openers = [document.getElementById('rp-size-guide-open'), document.getElementById('rp-trust-size')].filter(Boolean);
    var closer = document.getElementById('rp-modal-close');
    var overlay = document.getElementById('rp-modal-overlay');

    function openModal() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      closer.focus();
    }
    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }
    openers.forEach(function(el) { el.addEventListener('click', openModal); });
    closer.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);

    /* Tabs */
    modal.addEventListener('click', function(e) {
      var tab = e.target.closest('.rp__tab');
      if (!tab) return;
      modal.querySelectorAll('.rp__tab').forEach(function(t) { t.classList.remove('rp__tab--active'); t.setAttribute('aria-selected', 'false'); });
      tab.classList.add('rp__tab--active');
      tab.setAttribute('aria-selected', 'true');
      var target = tab.dataset.tab;
      modal.querySelectorAll('.rp__tab-panel').forEach(function(p) {
        var show = p.dataset.panel === target;
        p.classList.toggle('rp__tab-panel--active', show);
        p.hidden = !show;
      });
    });
  }

  /* ESC key for modals */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (!lightbox.hidden) closeLightbox();
      if (modal && !modal.hidden) closeModal();
    }
  });

  /* AJAX Add to cart */
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    if (addBtn.disabled) return;
    addBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantInput.value), quantity: 1 })
    }).then(function(r) { return r.json(); }).then(function(data) {
      addBtn.classList.add('rp__add-btn--success');
      setTimeout(function() {
        addBtn.classList.remove('rp__add-btn--success');
        addBtn.disabled = false;
      }, 1500);
      /* Update cart count if theme supports it */
      var cartCount = document.querySelector('[data-cart-count], .cart-count, .js-cart-count');
      if (cartCount) {
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          cartCount.textContent = cart.item_count;
        });
      }
    }).catch(function() {
      addBtn.disabled = false;
    });
  });

  /* Sticky button mirrors form submit */
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function() {
      form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }

  /* Sticky bar visibility */
  if (stickyBar) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        stickyBar.classList.toggle('rp__sticky--visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      });
    }, { threshold: 0 });
    observer.observe(addBtn);
  }

  /* Gallery smooth scroll */
  gallery.style.scrollBehavior = 'smooth';

  /* Init soldout states */
  var initialVariant = findVariant();
  if (initialVariant) updateSoldoutSizes(initialVariant);
})();

  } catch(e) { console.error(e); }
})();
})();
